import FooterInfo from "./FooterInfo";
import styles from "./Footer.module.css";
import { ListView } from "../common/ListView";
import { FooterMenuList, FooterMenuListProps } from "./FooterMenuList";
import { path } from "../common/Common";

/**
 * @author yjkim
 * @date 2022-09-02 17:22
 * @remark 하단 footer
 * @returns Footer JSX.Element
 */

function Footer() {
    const footerATagDataList = [
        {
            text: "지도만들기",
            link: path.CREATE_MAP,
        },
        {
            text: "기능",
            link: path.GUIDE,
        },
        {
            text: "가격정책",
            link: path.PRICE_POLICY,
        },
        {
            text: "지원문의",
            link: path.SUPPORT,
        },
        {
            text: "회사소개",
            link: path.COMPANY_INFO,
        },
        {
            text: "개인정보보호 법률",
            link: path.TERMS,
        },
        {
	      text: "이용약관",
	      link: path.TERMS,
	    },
	    {
	      text: "개인정보처리방침",
	      link: path.PRIVACY,
	    },
	];

    const renderItem = (item: FooterMenuListProps) => {
        return <FooterMenuList text={item.text} link={item.link} />;
    };

    return (
        <div>
            <footer>
                <div className={styles.footerMenuBar}>
                    <ul className={styles.footerMenu}>
                        <ListView
                            data={footerATagDataList}
                            renderItem={(item, index) => <FooterMenuList key={index} text={item.text} link={item.link} />}
                        />
                    </ul>
                </div>
                <FooterInfo></FooterInfo>
            </footer>
        </div>
    );
}

export default Footer;
